<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="150px"
      :model="formLabelAlign"
    >
      <el-form-item label="规则名称">
        <el-input
          v-model="formLabelAlign.name"
          class="in_dwer"
        />
      </el-form-item>
      <el-form-item label="回传开关">
        <el-radio-group v-model="formLabelAlign.is_open">
          <el-radio-button :label="0">关闭</el-radio-button>
          <el-radio-button :label="1">开启</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="行为类型">
        <el-radio-group v-model="formLabelAlign.action_type">
          <el-radio-button :label="1">下单</el-radio-button>
          <el-radio-button :label="2">加企微客服</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="配置列表">
        <el-form-item>
          <div>
            每个广告主 每日先回传
            <el-input-number
              v-model="formLabelAlign.part_pre_num"
              size="mini"
              :min="0"
            /> 笔，再按如下策略进行回传
          </div>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="formLabelAlign.part_type">
          <el-radio-button
            :label="1"
            style="margin-bottom: 10px;"
          >百分比回传</el-radio-button>
          <el-radio-button :label="2">循环比例回传<el-tooltip
            content="选项左侧值为上报，右侧为不上报，默认5:1，如果选择2:1，就是第1笔不上报，第2，3笔上报，第4笔不上报，第5，6笔上报，如此循环"
            placement="top"
          >
            <i
              class="el-icon-info"
              style="font-size: 15px;margin-left: 10px;"
            />
          </el-tooltip></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="formLabelAlign.part_type == 1">
        <el-radio-group v-model="formLabelAlign.part_rate">
          <el-radio :label="10">10%</el-radio>
          <el-radio :label="20">20%</el-radio>
          <el-radio :label="30">30%</el-radio>
          <el-radio :label="40">40%</el-radio>
          <el-radio :label="50">50%</el-radio>
          <el-radio :label="60">60%</el-radio>
          <el-radio :label="70">70%</el-radio>
          <el-radio :label="80">80%</el-radio>
          <el-radio :label="90">90%</el-radio>
          <el-radio :label="100">100%</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if=" formLabelAlign.part_type == 2"
        label="比例选择"
      >
        <el-select
          v-model="copypart_rate"
          placeholder="比例选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if=" formLabelAlign.part_type == 2"
        label="循环规则"
      >
        <el-radio-group v-model="formLabelAlign.part_loop_type">
          <el-radio-button
            :label="1"
            style="margin-bottom: 10px;"
          >按记录轮询</el-radio-button>
          <el-radio-button :label="2">每日重置</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否回传全部账户">
        <el-radio-group v-model="formLabelAlign.is_all_account">
          <el-radio-button :label="0">否</el-radio-button>
          <el-radio-button :label="1">是</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.is_all_account === 0"
        label="请选择账户"
      >
        <el-button type="primary" size="mini" @click="addAccount">选择账号</el-button>
        <el-tag v-for="item,index in all_accounts" :key="index" closable style="margin-left: 10px" @close="removeAccount">{{ item }}</el-tag>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="'选择账户'"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="50%"
    >
      <account ref="account" :account_list="all_accounts" @commit="addAccountList" @close="dialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import { tencentBackRuleAdmincreate, tencentBackRuleAdminupdate } from '@/api/customer'
import Account from '@/views/tencentAD/backhaul/components/account.vue'
export default {
  components: { Account },
  data() {
    return {
      all_accounts: [],
      dialogVisible: false,
      labelPosition: 'right',
      type: 1,
      formLabelAlign: {
        name: '',
        is_open: 1,
        rule_param: [],
        is_all_account: 1,
        part_pre_num: 1,
        part_type: 1,
        part_loop_type: 1,
        part_rate: 100,
        action_type: 1
      },
      copypart_rate: 100,
      options: [
        {
          value: 100,
          label: '1:1'
        },
        {
          value: 67,
          label: '2:3'
        },
        {
          value: 50,
          label: '1:2'
        },
        {
          value: 150,
          label: '3:2'
        },
        {
          value: 250,
          label: '5:2'
        },
        {
          value: 200,
          label: '2:1'
        },
        {
          value: 300,
          label: '3:1'
        },
        {
          value: 400,
          label: '4:1'
        },
        {
          value: 500,
          label: '5:1'
        },
        {
          value: 600,
          label: '6:1'
        },
        {
          value: 700,
          label: '7:1'
        },
        {
          value: 800,
          label: '8:1'
        },
        {
          value: 900,
          label: '9:1'
        }
      ],
      typer: 1,
      id: null,
      settingData: [{ event_name: 123123, part_type: 1 }],
      mpAdvertiserList: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    typelist(value) {
      console.log('value', value)
    },
    sumbitr() {
      const obj = {}
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.name == '') {
        this.$message({
          message: '请填写规则名称',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.is_all_account === 0 && this.all_accounts.length === 0) {
        return this.$message({
          message: '请选择账户',
          type: 'error'
        })
      } else {
        obj.account_list = this.all_accounts
      }
      // eslint-disable-next-line eqeqeq
      if (this.typer == 1) {
        // 是否开启回传部分订单
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.part_type == 1) {
          console.log('百分比')
          obj.part_rate = this.formLabelAlign.part_rate
        } else {
          obj.part_rate = this.copypart_rate
          obj.part_loop_type = this.formLabelAlign.part_loop_type
          console.log('循环比例回传')
        }
        tencentBackRuleAdmincreate({
          name: this.formLabelAlign.name,
          is_open: this.formLabelAlign.is_open,
          part_pre_num: this.formLabelAlign.part_pre_num,
          part_type: this.formLabelAlign.part_type,
          ...obj,
          is_all_account: this.formLabelAlign.is_all_account,
          action_type: this.formLabelAlign.action_type
        }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$emit('updata')
            this.$message({
              message: '添加成功',
              type: 'success'
            })
          }
        })
      } else {
        const obj = {}
        //  是否回传全部账户
        if (this.formLabelAlign.is_all_account === 0 && this.all_accounts) {
          obj.account_list = this.all_accounts
        }
        // 是否开启回传部分订单
        obj.part_pre_num = this.formLabelAlign.part_pre_num
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.part_type == 1) {
          console.log('百分比')
          obj.part_rate = this.formLabelAlign.part_rate
        } else {
          obj.part_rate = this.copypart_rate
          obj.part_loop_type = this.formLabelAlign.part_loop_type
          console.log('循环比例回传')
        }
        tencentBackRuleAdminupdate({
          id: this.id,
          name: this.formLabelAlign.name,
          is_open: this.formLabelAlign.is_open,
          part_type: this.formLabelAlign.part_type,
          ...obj,
          is_all_account: this.formLabelAlign.is_all_account,
          action_type: this.formLabelAlign.action_type
        }).then(res => {
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$emit('updata')
            this.$message({
              message: '修改成功',
              type: 'success'
            })
          }
        })
      }
    },
    addAccount() {
      this.dialogVisible = true
      console.log(1)
    },
    addAccountList(val) {
      this.all_accounts = val
      this.dialogVisible = false
    },
    removeAccount(val) {
      console.log(val)
      this.all_accounts.splice(val, 1)
    },
    send(type, val) {
      console.log(type)
      this.typer = type
      if (type === 2) {
        this.formLabelAlign = val
        this.all_accounts = val.account_ids
        this.id = val.id
        this.action_type = val.action_type
        // eslint-disable-next-line eqeqeq
        if (val.part_type == 2) { this.copypart_rate = val.part_rate }
      }
      console.log(val)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.in_dwer {
  width: 400px;
}
</style>
